<template>
	<div>
		<PagesHeading :path2="category.name" :path2Slug="category.slug" :path3="oneProduct.name" />
		<div class="d-flex row m-0 justify-content-center">
			<div id="product" class="col-12" :class="{ 'loading-app-style': loading }">
				<div v-if="loading" class="py-5" style="display: flex; align-items: center; justify-content: center">
					<div  class="loader"></div>
				</div>
				<div v-else class="row">
					<div class="col-12 col-md-8 left-border">
						<div class="row">
							<div class="container px-5 product-content">
								<span>{{oneProduct.name }}</span>
								<p v-html="oneProduct.description"></p>
							</div>
						</div>
						<!-- v-if="index !== 0" -->
						<!-- <div class="row">
							<div class="owl-carousel">
								<a v-for="(img, k) in oneProduct.images" :key="k" data-toggle="lightbox"
									data-gallery="news-images">
									<img id="sliderImages" alt="Snow"
										style="width:90%;margin: 0px 5%;max-width:273px; height: 300px !important;"
										:src="img.url" class="img-fluid same-height cover">
								</a>
							</div>
						</div> -->
					</div>
					<div  class="col-12 col-md-4 px-0 d-none d-md-block product-section position-relative">
						<div class="rectangle"></div>
							<img  :src="oneProduct.primaryImage.url" style="width: 20vw; opacity: 0.9;">
					</div>
				</div>
	
				<div v-if="!loading" class="row d-flex justify-content-center">
					<div class="col-11">
						<h4 class="more-product">{{$t('products.related-products')}} :</h4>
						<div class="row">
							<div v-for="(relatedProduct, i) in relatedProducts" :key="i" class="col-sm-6 col-lg-4 col-12 d-flex justify-content-center"
								style="margin-top:10vh; margin-bottom:5vh">
								<div class="card" style="width: 18rem;">
									<div class="card-body">
										<router-link :to="{name: 'product-view', params: {productSlug: relatedProduct.slug, categorySlug: $route.params.categorySlug} }"
											class="no-decoration">
											<img :src="relatedProduct.primaryImage.url" class="img-fluid same-height cover"
												style="width: 60%; left: 20%">
										</router-link>
									</div>
									<div class="container card-product-content">
										<h5 class="card-title text-center font-weight-bold">{{relatedProduct.name }}</h5>
										<p class="card-text text-center" v-html="relatedProduct.description"></p>
									</div>
									<router-link :to="{name: 'product-view', params: {productSlug: relatedProduct.slug, categorySlug: $route.params.categorySlug} }"
										style="text-decoration: none !important" :key="$route.fullPath" >
										<button class="read-more">{{$t('common.read-more')}}</button>
									</router-link>
								</div>
							</div>
						</div>
					</div>
				</div>
	
			</div>
		</div>
	</div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import PagesHeading from '@/components/PagesHeading.vue';
export default {
	components: {
		PagesHeading
	},
	data() {
		return {
			loading: true,
			imgLoad: true,
		}
	},
	computed: {
		...mapState({
			products: state => state.products.products,
			categories: state => state.categories.categories
		}),
		category () {
			if (this.categories[0]) {
				return this.categories.find(t => t.slug === this.$route.params.categorySlug);
			} else {
				return '';
			}
		},
		oneProduct() {
			if (this.products[0]) {
				return this.products.find(t => t.slug === this.$route.params.productSlug);
			} else {
				return '';
			}
		},
		relatedProducts() {
			return this.products.filter(t => t.slug !== this.$route.params.productSlug);
		}
	},
	methods: {
		...mapActions('products', ['fetchProducts']),
		...mapActions('categories', ['fetchCategories']),
		fetch() {
			if (!this.products[0]) {
				this.fetchProducts(this.$route.params.categorySlug)
					.finally(() => { this.loading = false });
			} else {
				this.loading = false
			}
			if (!this.categories[0]) {
				this.fetchCategories();
			}
		}
	},
	created() {
		this.fetch();
	}
}
</script>
<style scoped>
body {
	background: #fff;
}

.rectangle {
	background-color: #ff8c00;
	height: 75vh;
	background-image: url('../../public/images/potato.png');
	background-repeat: no-repeat;
	background-size: 100%;
	background-position: bottom right;
	border-bottom-left-radius: 15px;
	opacity: 0.6;
	position: relative;
}

.product-section img {
	position: absolute;
	margin-top: -70vh;
}

.product-content span {
	font-size: 3rem;
	color: #FCAD4D;
}

.product-content h4 {
	color: #FCAD4D;
	margin-bottom: 0px;
	margin-bottom: -6vh;
	margin-left: 32vh;
	font-size: 24px;
}

.left-border {
	border-left: 30px solid #FCAD4D;
	margin-top: 10vh;
}

.card {
	background: url('../../public/images/products-background-opacity.png');
	background-color: #e9e8e4;
	background-size: 100%;
	background-repeat: no-repeat;
	background-position: top right;
	height: 200px;
	border-radius: 18px;
	border: 0px;
	box-shadow: -1px 2px 8px rgba(0, 0, 0, 0.25);
	height: 450px;
	transition: all 0.5s ease, transform 0.5s ease;

}

.card:hover {
	background-color: #FCAD4D;
	transform: scale(1.1);
	box-shadow: -1px 2px 18px rgba(0, 0, 0, 0.25);

}

.card-body h3 {
	margin-top: 3vh;
}

.card-body img,.imgLoader {
	position: absolute;
	top: -52px;
	bottom: 0;
	left: 60px;
}

.card-body {
	flex: 0.5 0.5 auto;
	padding: 1.25rem;
}

.card-product-content {
	color: #7e7e7e;
}

.read-more {
	display: none;

}

.card:hover a {
	display: flex;
	justify-content: center;
}

.card:hover .read-more {
	display: flex;
	border: 1px solid #fff;
	color: #FCAD4D;
	border-radius: 30px;
	padding: 4px 60px;
	background-color: #fff;
	margin-top: 8vh;
	justify-content: center;
	text-decoration: none !important;
}

.card:hover .card-product-content {
	color: #fff;
	margin-top: 10vh;
}

.card:hover .card-text {
	color: #fff;
}
.card-text{
	display: -webkit-box;
	-webkit-line-clamp: 5; 
	-webkit-box-orient: vertical;
	overflow: hidden;
}
.owl-carousel {
	/**background-color: #e9e8e4;*/
	padding: 20px 0px 0px 0;
	border-bottom-right-radius: 15px;
	border-top-right-radius: 15px;
	width: 80%;
	margin-top: 40px;
}

img.same-height {
	height: 200px;
}

.cover {
	object-fit: cover;
}

.more-product {
	font-size: 2rem;
	color: #FCAD4D;
	margin-top: 12%;
}

html[dir='rtl'] .left-border {
	border-right: 30px solid #FCAD4D;
	border-left: none;
}

html[dir='rtl'] .product-content {
	text-align: right;
}

html[dir='rtl'] .owl-carousel {
	border-bottom-left-radius: 15px;
	border-top-left-radius: 15px;
	border-bottom-right-radius: 0;
	border-top-right-radius: 0;
}

html[dir="rtl"] .owl-wrapper-outer {
	direction: ltr;
}

html[dir='rtl'] .rectangle {
	border-bottom-right-radius: 15px;
	border-bottom-left-radius: 0;
	background-image: url('../../public/images/potato-ar.png');
	background-position: bottom left;
}

html[dir='rtl'] .more-product {
	text-align: right;
}

html[dir='rtl'] .product-section img {
	position: absolute;
	margin-top: -65vh;
	margin-left: 0;
}

@media(max-width : 575px) {
	.owl-carousel {
		width: 90%;
	}

	.beeContainer {
		max-width: 90%;
	}
}
</style>
